import type { BlockAuthFormSocialConnectionsApi } from "@-/dev.improve.haniverse.components.ui.block-auth-form";
import { AppleSignInButton } from "@-/dev.improve.haniverse.routes.nav.app.auth._components.buttons.apple";
import { GoogleSignInButton } from "@-/dev.improve.haniverse.routes.nav.app.auth._components.buttons.google";
import { View } from "@-/com.npmjs.react-native";
import type { ReactNode } from "react";

/**
 * `BlockAuthForm` only calls this with at least one available provider (it skips the renderer
 * entirely otherwise), so there is no hidden case to handle here.
 */
export function renderAuthSocialSignIn({
  compact,
  disabled,
  providers,
}: BlockAuthFormSocialConnectionsApi): ReactNode {
  return (
    <View className={compact ? "gap-2" : "gap-3"}>
      {providers.map(({ onPress, pending, provider }) =>
        provider === "apple" ? (
          <AppleSignInButton
            compact={compact}
            disabled={disabled}
            key={provider}
            onPress={onPress}
            pending={pending}
          />
        ) : (
          <GoogleSignInButton
            compact={compact}
            disabled={disabled}
            key={provider}
            onPress={onPress}
            pending={pending}
          />
        ),
      )}
    </View>
  );
}
